import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import WorkingHoursBar from './components/WorkingHoursBar';
import ContactCards from './components/ContactCards';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import CallCenterSection from './components/CallCenterSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';

export default function HomePage() {
  return (
    <main className="font-sans">
      <Navbar />
      <HeroSection />
      <WorkingHoursBar />
      <ServicesSection />
      <AboutSection />
      <WhyChooseUsSection />
      <CallCenterSection />
      <ContactCards />
      <TestimonialsSection />
      <ContactSection />
      <Footer />
      <FloatingButtons />
    </main>
  );
}
